import { formatDate } from "@";
// Table columns configuration
const tableColumns = [
  {
    name: "الرسالة",
    selector: ({ body }) =>
      body.length > 100 ? body?.substring(0, 100) + "..." : body,
    grow: 3,
  },
  {
    name: "التاريخ",
    selector: ({ submittingDate }) => formatDate(submittingDate),
  },
];

export default tableColumns;
